import React from "react";
import TextInput, { type TextInputProps } from "./TextInput";

const PasswordInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  function PasswordInput(props, ref) {
    return <TextInput ref={ref} {...props} type="password" />;
  }
);

export default PasswordInput;
